import { useState } from 'react';
import LoadingWeatherCards from './../Loading/LoadingWeatherCards';
import LayoutGrid from './../Layout/LayoutGrid';
import TabNav from './TabNav';
import TabContent from './TabContent';

const Tabs = ({ loading, firstTab, secondTab }) => {
	const [activeTab, setActiveTab] = useState('local');

	return (
		<div className='tabs'>
			<ul className='tabs__nav'>
				<TabNav title='Local' id='local' activeTab={activeTab} setActiveTab={setActiveTab} />
				<TabNav title='Regional' id='regional' activeTab={activeTab} setActiveTab={setActiveTab} />
			</ul>
			<div className='tabs__body'>
				<TabContent id='local' activeTab={activeTab}>
					{loading ? (
						<LayoutGrid columns={9} rows={1}>
							{firstTab}
						</LayoutGrid>
					) : (
						<LayoutGrid columns={9} rows={1}>
							<LoadingWeatherCards elements={9} />
						</LayoutGrid>
					)}
				</TabContent>
				<TabContent id='regional' activeTab={activeTab}>
					{loading ? (
						<LayoutGrid columns={9} rows={2}>
							{secondTab}
						</LayoutGrid>
					) : (
						<LayoutGrid columns={9} rows={2}>
							<LoadingWeatherCards elements={27} />
						</LayoutGrid>
					)}
				</TabContent>
			</div>
		</div>
	);
};

export default Tabs;
